import { optional, z } from "zod";
import { refine } from '@conform-to/zod';

export const loginSchema = z.object({
  email: z.string({ message: "User id is required field" }).min(3).max(30),
  password: z.string({ message: "Password is required field" }).min(3),
})
export const oneTimeSettlementSchema = z.object({
  service_no: z.string({ message: "Service no is required field" })
})

export const LtNewConnectionRegSchema1 = z.object({
  admission_no: z.string({ message: "adm no is required field" }).min(21).max(21),
})

export const LtNewConnectionRegSchema2 = z.object({
  ext_con_name: z.string({ message: "con name is required field" }).min(3).max(30),
  ext_fath_name: z.string({ message: "father name is required field" }).min(3).max(30),
})

export const LtNewConnectionRegSchema3 = z.object({
  service_num: z.string({ message: "Service no is required field" }).min(13).max(13)
})

export const LtNewConnectionRegSchema = z.object({
  //section 1
  existing_customer: z.string({ message: "Existing customer is required field" }),
  admission_no: z.string({ message: "Admission number is required field" }).optional(),
  ext_pwr_line: z.string({ message: "Existing power line is required field" }),
  consumer_name: z.string({ message: "Consumer name is required field" }).min(3).max(250).optional(),
  gender_type: z.string({ message: "Gender type is required field" }),
  consumer_age: z
    .string({ message: "Consumer age is required field" })
    .regex(/^(1[89]|[2-9][0-9]|100)$/, {
      message: "Consumer age must be between 18 and 100",
    }),
  father_name: z.string({ message: "Father name is required field" }).min(3).max(30).optional(),
  organization_or_not: z.string({ message: "Organisation is required field" }),
  mobile_no: z.string({ message: "Mobile number is a required field" })
    .refine(value => /^[6-9]\d{9}$/.test(value), { message: "Mobile number must be 10 digits and start with 6, 7, 8, or 9." }).optional(),
  //organisation === yes
  organization_name: z.string().optional(),
  organization_applicant_desg: z.string().optional(),

  // mobile_otp: z.string({ message: "Mobile otp is required field" }).min(6).max(6).optional(),
  email_id: z.string({ message: "Email is an required field" }).email("Invalid email address").optional(),
  gov_emp: z.string({ message: "Govt Employee is required field" }),
  service_no: z.string().min(13).max(13).optional(),
  circle_name: z.string({ message: "Circle Name is required field" }),
  mandal: z.string({ message: "Mandal name is required field" }),
  section_name: z.string({ message: "Section name is required field" }),
  distribution: z.string({ message: "Distribution name is required field" }),
  location_type: z.string({ message: "Locality type is required field" }),
  area: z.string({ message: "landmark is required field" }).min(3).max(30).optional(),

  //lt8
  no_of_days: z.string({ message: "No of days is required field" }).optional(),
  no_of_hrs: z.string({ message: "No of hours is required field" }).optional(),
  lt_type: z.string({ message: "Lt type is required field" }).optional(),

  // section 2
  connection_door_no: z.string({ message: "Door number is required field" }).min(3).max(30).optional(),
  connection_village: z.string({ message: "Village name is required field" }).min(3).max(30).optional(),
  connection_mandal_name: z.string({ message: "Mandal name is required field" }).min(3).max(30).optional(),
  connection_street_name: z.string({ message: "Street name is required field" }).min(3).max(30).optional(),
  connection_town: z.string({ message: "Town name is required field" }).min(3).max(30).optional(),
  connection_pincode: z.string({ message: "Pincode is required field" }).min(6).max(6).optional(),
  consumer_address_same_as_old: z.string({ message: "Address for communication is required field" }).optional(),

  // section 3
  communication_door_no: z.string().optional(),
  communication_village: z.string().optional(),
  communication_mandal_name: z.string().optional(),
  communication_street_name: z.string().optional(),
  communication_town: z.string().optional(),
  communication_pincode: z.string().optional(),

  // section 4
  category: z.string({ message: "Category is required field" }),
  scheme_type: z.string({ message: "Scheme type is required field" }),
  borewell_or_not: z.string({ message: "Borewell exists or not is required field" }).optional(),
  borewell_date: z.string({ message: "Borewell dig date is required field" }).optional(),
  borewell_process: z.string({ message: "Borewell process is required field" }).optional(),
  link_domestic_service_no: z.string({ message: "Linked domestic service is required field" }).min(13).max(13).optional(),
  building_type: z.string({ message: "Building type is required field" }).optional(),
  no_of_flats: z.number({ message: "No of flats is required field" }).min(0).max(5, { message: "PLEASE GO WITH LT APARTMENTS REGISTRATION, IF MULTISTORAGE IS ABOVE 5 FLATS." }).optional(),
  consumer_type: z.string({ message: "Consumer type is required field" }),
  social_group: z.string({ message: "Social group is required field" }),
  service_type: z.string({ message: "Service type is required field" }),
  purpose_of_supply: z.string({ message: "Purpose of supply is required field" }),
  rental_type: z.string({ message: "Rental type is required field" }),
  phase: z.string({ message: "Phase type is required field" }),
  estimation_type: z.string({ message: "Estimation type is required field" }),
  aadhar: z.string({ message: "Aadhar no is required field" }).min(12, { message: "Aadhar Number must accept only 12 digits" }).max(12, { message: "Aadhar Number must accept only 12 digits" }).optional(),
  gst_number: z.string({ message: "Gst number is required field" }).min(15).max(15).optional(),
  execution_type: z.string({ message: "Execution is required field" }),
  remarks: z
    .string().optional(),
  contract_load: z.number({ message: "Contract load is required field" }).min(0.1).max(250).optional(),
  loadtype: z.string({ message: "Load type is required field" }),

  // section 5
  id_proof: z.string({ message: "Id proof is required field" }).optional(),
  owner_doc: z.string({ message: "Owner doc is required field" }).optional(),
  id_proof_file: z.string({ message: "Upload id proof file is required field" }).optional(),
  owner_doc_file: z.string({ message: "Upload ownership doc file is required field" }).optional(),
  photo: z.string({ message: "Upload user photo is required field" }).optional(),
  // caste sc and st
  caste_certificate: z.string().optional(),
  //lt5a1 (corporate farmers)
  walta_certificate_copy: z.string().optional(),
  drilled_agency_certificate_copy: z.string().optional(),
  pattadhar_passbook_copy: z.string().optional(),
  income_certificate_copy: z.string().optional(),
  other_services_certificate: z.string().optional(),
  crop_history_certificate: z.string().optional(),
  no_objection_certificate: z.any().optional(),

}).superRefine((data, ctx) => {
  if (data?.borewell_or_not === "No") {
    ctx.addIssue({
      path: ['borewell_or_not'],
      message: 'WITHOUT BOREWELL, LT5 REGISTRATION NOT POSSIBLE',
      code: z.ZodIssueCode.custom,
    });
  }
})
  .superRefine((data, ctx) => {
    // if (data?.existing_customer === 'Yes') {
    //   if (!data.admission_no || data.admission_no.length < 10|| data.admission_no.length > 30) {
    //     ctx.addIssue({
    //       path: ['admission_no'],
    //       message: 'Admission number must be 10 digits',
    //       code: z.ZodIssueCode.custom,
    //     });
    //   }
    // }
    // 👇 Caste certificate mandatory for SC/ST
    if (data.social_group === '1' || data.social_group === '2') {
      if (!data.caste_certificate) {
        ctx.addIssue({
          path: ['caste_certificate'],
          message: 'Caste certificate is required when Social Group is SC or ST',
          code: z.ZodIssueCode.custom,
        });
      }
    }

    // 👇 Communication address validation if address is not same
    if (data.consumer_address_same_as_old === 'No') {
      if (!data.communication_door_no || data.communication_door_no.length < 3) {
        ctx.addIssue({ path: ['communication_door_no'], message: 'New door number is required', code: z.ZodIssueCode.custom });
      }
      if (!data.communication_village || data.communication_village.length < 3) {
        ctx.addIssue({ path: ['communication_village'], message: 'New village is required', code: z.ZodIssueCode.custom });
      }
      if (!data.communication_mandal_name || data.communication_mandal_name.length < 3) {
        ctx.addIssue({ path: ['communication_mandal_name'], message: 'New mandal name is required', code: z.ZodIssueCode.custom });
      }
      if (!data.communication_street_name || data.communication_street_name.length < 3) {
        ctx.addIssue({ path: ['communication_street_name'], message: 'New street name is required', code: z.ZodIssueCode.custom });
      }
      if (!data.communication_town || data.communication_town.length < 3) {
        ctx.addIssue({ path: ['communication_town'], message: 'New town name is required', code: z.ZodIssueCode.custom });
      }
      if (!data.communication_pincode || data.communication_pincode.length !== 6) {
        ctx.addIssue({ path: ['communication_pincode'], message: 'New pincode must be 6 digits', code: z.ZodIssueCode.custom });
      }
    }

    // 👇 Mandatory certificates when category is LT5A1
    if (data.category === "LT5A1") {
      const lt5a1Fields = [
        'walta_certificate_copy', 'drilled_agency_certificate_copy',
        'pattadhar_passbook_copy', 'income_certificate_copy',
        'other_services_certificate', 'crop_history_certificate',
        'no_objection_certificate'
      ];
      for (const field of lt5a1Fields) {
        if (!data[field]) {
          ctx.addIssue({ path: [field], message: `${field.replace(/_/g, ' ')} is required for LT5A1 Purpose`, code: z.ZodIssueCode.custom });
        }
      }
    }

    // 👇 Additional checks for LT8
    if (data.category === "LT8") {
      if (!data.no_of_hrs) {
        ctx.addIssue({ path: ['no_of_hrs'], message: 'No of hours is required field' });
      }
      if (!data.no_of_days) {
        ctx.addIssue({ path: ['no_of_days'], message: 'No of days is required field' });
      }
      if (!data.location_type) {
        ctx.addIssue({ path: ['location_type'], message: 'Location Type is required field' });
      }
    }

    // 👇 Organization related checks
    if (
      (data.organization_or_not === 'Yes' || data.consumer_type === 2 || data.consumer_type === 3) &&
      data.ext_pwr_line !== 'ext_yes'
    ) {
      if (!data.organization_name) {
        ctx.addIssue({
          path: ['organization_name'],
          message: 'Company name is required when organization is Yes and ext_pwr_line is not ext_yes',
        });
      }
      if (!data.organization_applicant_desg) {
        ctx.addIssue({
          path: ['organization_applicant_desg'],
          message: 'Applicant designation is required when organization is Yes and ext_pwr_line is not ext_yes',
        });
      }
    }

    const conditionalFields = [
      "consumer_name",
      "father_name",
      "mobile_no",
      // "email_id",
      "area",
      "connection_door_no",
      "connection_village",
      "connection_mandal_name",
      "connection_street_name",
      "connection_town",
      "connection_pincode",
      "consumer_address_same_as_old",
      "contract_load",
      "aadhar",
      "id_proof",
      "owner_doc",
      "id_proof_file",
      "owner_doc_file",
      "photo"
    ];

    const lengthRestrictedFields = [
      "consumer_name",
      "father_name",
      // "email_id"
    ];

    if (data.ext_pwr_line === "ext_no") {
      conditionalFields.forEach((field) => {
        const value = data[field];

        // ✅ Required validation
        if (
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "") ||
          (typeof value === "number" && isNaN(value))
        ) {
          const fieldNameFormatted = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, char => char.toUpperCase());

          ctx.addIssue({
            path: [field],
            code: z.ZodIssueCode.custom,
            message: `${fieldNameFormatted} is required when ext pwr line is ext no`,
          });

          return; // ⬅ stop further validation for this field
        }

        // ✅ Min–Max length validation (only for selected fields)
        if (
          lengthRestrictedFields.includes(field) &&
          typeof value === "string"
        ) {
          const trimmedValue = value.trim();

          if (trimmedValue.length < 3 || trimmedValue.length > 30) {
            const fieldNameFormatted = field
              .replace(/_/g, " ")
              .replace(/\b\w/g, char => char.toUpperCase());

            ctx.addIssue({
              path: [field],
              code: z.ZodIssueCode.custom,
              message: `${fieldNameFormatted} must be between 3 and 30 characters`,
            });
          }
        }
      });
    }
  });


const multiDotNumberRegex = /^[0-9.]+$/;
export const onlineRegForRythuNestamSchema = z.object({
  consumer_name_as_aadhar: z
    .string({ message: "Consumer name is required field" }).min(3, "Consumer name must atleast of 3 characters").max(250),
  consumer_name_as_bank: z
    .string({ message: "Account holder name is required field" }).min(3, "Account holder name must atleast of 3 characters").max(250),
  consumer_name: z.string({ message: "Consumer name is required field" }).min(3).max(250).optional(),
  gender_type: z.string({ message: "Gender type is required field" }),
  consumer_age: z
    .string({ message: "Consumer age is required field" })
    .regex(/^(1[89]|[2-9][0-9]|100)$/, {
      message: "Consumer age must be between 18 and 100",
    }),
  father_name: z.string({ message: "Father name is required field" }).min(3, "Father name must atleast of 3 characters").max(150),
  aadhar: z.string({ message: "Aadhar number is required field" }).min(12, "Aadhar no must atleast of 12 digits").max(12),
  mobile_no: z.string({ message: "Mobile number is a required field" })
    .refine(
      (value) => /^[6-9]\d{9}$/.test(value),
      { message: "Mobile number must be 10 digits and start with 6, 7, 8, or 9." }
    ),
  // mobile_otp: z.string({ message: "Mobile otp is required field" }).min(6, "Otp no must atleast 6 digits").max(6),

  email_id: z.string().email().optional(),
  bank_name: z.string({ message: "Bank name is required field" }),
  circle_name: z.string({ message: "Circle Name is required field" }),
  mandal: z.string({ message: "Mandal name is required field" }),
  section_name: z.string({ message: "Section name is required field" }),
  distribution: z.string({ message: "Distribution is required field" }),
  bank_account_no: z.string({ message: "Bank AC no is required field" }).min(10).max(16),
  borewell_latitude: z
    .string()
    .regex(multiDotNumberRegex, "Only numbers and dots are allowed")
    .min(3, "Borewell latitude must atleast of 3 characters")
    .max(30)
    .optional(),

  borewell_longitude: z
    .string()
    .regex(multiDotNumberRegex, "Only numbers and dots are allowed")
    .min(3, "Borewell longitude must atleast of 3 characters")
    .max(30)
    .optional(),
  pattaadhar_passbook_no: z.string({ message: "Pattaadhar passbook no is an required field" }).min(3, "Pattaadhar passbook no must atleast of 3 characters").max(30),
  survey_no: z.string({ message: "Survey no is required field" }).min(1, " Survey no must atleast of 3 characters").max(11),
  extent_land: z.string({ message: "Extent of land is required field" }).min(3, "Extend land must atleast of 3 characters").max(30),
  village_name: z.string({ message: 'Village name is required field' }).min(3, "Village must atleast of 3 characters").max(30),
  premises_mandal: z.string({ message: "Mandal name is required field" }).min(3, "Mandal is must atleast of 3 characters").max(30),
  pin_code: z.string({ message: "Pincode is required field" }).min(6, "Pincode must atleast of 6 characters").max(6),
  landmark_name: z.string({ message: "Landmark is required field" }).min(3, "Landmark must atleast of 3 characters").max(30),
  communication_door_no: z.string({ message: "Door number is required field" }).min(3, "Door no must atleast of 3 characters").max(30),
  communication_street_name: z.string({ message: "Street name is required field" }).min(3, "Street name must atleast of 3 characters").max(30),
  communication_town: z.string({ message: "Town name is required field" }).min(3, "Town name must atleast of 3 characters").max(30),
  communication_mandal: z.string({ message: "Mandal name is required field" }).min(3, "Mandal name must atleast of 3 characters").max(30),
  district_name: z.string({ message: "District name is required field" }).min(3, "District name must atleast of 3 characters").max(30),
  communication_pincode: z.string({ message: "Communication pincode is required field" }).min(6, "Pincode must atleast of 6 digits").max(6),
  category: z.string({ message: "Lt Category is required field" }),
  scheme_type: z.string({ message: "Scheme type is required field" }),
  link_domestic_service_no: z.string({ message: "Linked domestic service is required field" }).min(13, "Linked domestic SC no must atleast of 13 digits").max(13),
  consumer_type: z.string({ message: "Consumer type is required field" }),
  social_group: z.string({ message: "Social group is required field" }),
  purpose_of_supply: z.string({ message: "Purpose of supply is required field" }),
  phase: z.string({ message: "Phase type is required field" }),
  estimate: z.string({ message: "Estimation type is required field" }),
  no_objection_fixing: z
    .string({ message: "No objection for fixing is required field" })
    .refine((val) => val !== "no", {
      message: "LT5 REGISTRATION NOT POSSIBLE IF FIXING OF METER OBJECTION IS NO.",
    }),
  constract_load: z
    .string({ message: "Contract load is required field" })
    .regex(/^(200(\.0+)?|1\d{2}(\.\d+)?|[1-9]\d?(\.\d+)?)$/, {
      message: "Connected Load should be between 1 and 200 HP",
    }),
  metrics: z.string({ message: 'Metrics is required field' }),

  id_proof: z.string({ message: "Upload apwalta is a required field" }).optional(),
  // .refine((file) => file instanceof File, {
  //   message: "ID proof is a required field",
  // })
  // .refine((file) => file && file.size <= 1 * 1024 * 1024, {
  //   message: "ID proof must be 1MB or less",
  // }),

  // Pattadar Passbook - checks for file type and existence
  upload_passbook: z.string({ message: "Upload Pattadar passbook is a required field" }),
  // .refine((file) => file instanceof File, {
  //   message: "Upload Pattadar passbook is a required field",
  // })
  // .refine((file) => file && file.size <= 1 * 1024 * 1024, {
  //   message: "Pattadar passbook must be 1MB or less",
  // }),

  upload_bank_passbook: z.string({ message: "Upload first page of bank passbook copy is required field" }),
  // .refine((file) => file instanceof File, {
  //   message: "Upload first page of bank passbook copy is required field",
  // })
  // .refine((file) => file && file.size <= 1 * 1024 * 1024, {
  //   message: "Bank passbook must be 1MB or less",
  // }),

  upload_dbtr_mandate: z.string({ message: "Upload DBT mandate is required field" }),
  // .refine((file) => file instanceof File, {
  //   message: "Upload DBT mandate is required field",
  // })
  // .refine((file) => file && file.size <= 1 * 1024 * 1024, {
  //   message: "DBT mandate must be 1MB or less",
  // }),

  upload_aadhar: z.string({ message: "Upload Aadhar is required field" }),
  // .refine((file) => file instanceof File, {
  //   message: "Upload Aadhar is required field",
  // })
  // .refine((file) => file && file.size <= 1 * 1024 * 1024, {
  //   message: "Aadhar must be 1MB or less",
  // }),

  photo: z.string({ message: "Upload Consumer Photo is required field" }),

  upload_caste_certificate: z.string({ message: "Upload Caste Certificate is required field" }).optional(),
  // .refine((file) => file instanceof File, {
  //   message: "Upload Caste Certificate is required field",
  // })
  // .refine((file) => file && file.size <= 1 * 1024 * 1024, {
  //   message: "Caste certificate must be 1MB or less",
  // }),
}).superRefine((data, ctx) => {
  if (data.social_group === '1' || data.social_group === '2') {
    // Only when SC or ST
    if (!data.upload_caste_certificate) {
      ctx.addIssue({
        path: ['upload_caste_certificate'],
        message: 'Caste certificate is required when Social Group is SC or ST',
        code: z.ZodIssueCode.custom,
      });
    }
  }
});

export const serviceRequestRegistrationSchemaForm1 = z.object({
  service_type: z.string({ message: "Service Type is required field" }),
  category_type: z.string().optional(),
  service_number: z.string({ message: "Service no is required field" }).min(13, "Service no must atleast of 13 digits").max(13).optional(),
  scheme_type: z.string({ message: "Scheme type is required field" }),
  circle_name: z.string({ message: "Circle name is required field" }).optional(),
  mandal_name: z.string({ message: "Mandal name is required field" }).optional(),
  section_name: z.string({ message: "Section name is required field" }).optional(),
  location_type: z.string({ message: "Location type is required field" }).optional(),
  dtr_number: z.string().optional(),
}).superRefine((data, ctx) => {
  if (['9,54@Shifting of DTR', '9,66@Electrification of Layout', '9,99@Electrification of Colony', '9,4@Requirement of Additional Poles', '9,15@Temp Connection (for festivals)', '9,12@Other Capital Works'].includes(data.service_type)) {
    if (!data.circle_name || data.circle_name.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Circle is required field",
        path: ["circle_name"],
      });
    }
    if (!data.mandal_name || data.mandal_name.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Mandal is required field",
        path: ["mandal_name"],
      });
    }
    if (!data.section_name || data.section_name.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Section is required field",
        path: ["section_name"],
      });
    }
  }
}).superRefine((data, ctx) => {
  if (['9,5@Line Shifting / DTR Shifting'].includes(data.service_type)) {
    if (!data.circle_name || data.circle_name.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Circle is required field",
        path: ["circle_name"],
      });
    }
    if (!data.mandal_name || data.mandal_name.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Mandal is required field",
        path: ["mandal_name"],
      });
    }
    if (!data.section_name || data.section_name.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Section is required field",
        path: ["section_name"],
      });
    }
    if (!data.location_type || data.location_type.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Location type is required field",
        path: ["location_type"],
      });
    }
  }
}).superRefine((data, ctx) => {
  if (data.service_type === '9,81@AGL 16-25 kba') {
    if (!data.dtr_number || data.dtr_number.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Functional location number(DTR) is required field",
        path: ["dtr_number"],
      });
    }
  } else {
    if (!data.category_type || data.category_type.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Category type is required field",
        path: ["category_type"],
      });
    }
  }
})
export const serviceRequestRegistrationSchemaForm2 = z.object({
  service_type: z.string(),
  category_type: z.string(),
  service_number: z.string().optional(),
  scheme_type: z.string(),
  circle_name: z.string().optional(),
  mandal_name: z.string().optional(),
  section_name: z.string().optional(),
  location_type: z.string().optional(),
  dtr_number: z.string().optional(),

  consumer_name: z.string({ message: "Consumer name is required field" }).min(2, "Consumer name must atleast of 2 characters").max(250),
  father_name: z.string({ message: "Father name is required field" }).min(2, "Father name must atleast of 2 charcters").max(30),
  street_name: z.string({ message: "Street name is required field" }).min(2, "Street name must atleast of 2 characters").max(30),
  landmark: z.string({ message: "Landmark is required field" }).min(2, "Landmark atleast of 2 characters").max(30),
  excution_type: z.string().optional(),
  pin_code: z.string({ message: "Pin code is required field" }).min(6, "Pincode must atleast of 6 digits").max(6),
  contract_load: z.string().optional(),
  door_no: z.string({ message: "Door number is required field" }).min(2, "Door number must atleast of 2 characters").max(30),
  town_city: z.string({ message: "Town name is required field" }).min(2, "Town name must atleast of 2 characters").max(30),
  land_mark: z.string({ message: "Landmark is required field" }).min(2, "Landmark must atleast 2 characters").max(30).optional(),
  email_id: z.string({ message: "Email is required field" }).email().optional(),
  phase_type: z.string({ message: "Phase type is required field" }).optional(),
  con_meter_type: z.string().optional(),
  sc_type: z.string({ message: "Service type is required field" }).optional(),
  category: z.string({ message: "Category is required field" }).optional(),
  load_type: z.string({ message: "Load Type is required field" }).optional(),
  est_type: z.string({ message: "Estimation type is required field" }),
  mobile_no: z.string({ message: "Mobile number is a required field" }).refine(
    (value) => /^[6-9]\d{9}$/.test(value),
    { message: "Mobile number must be 10 digits and start with 6, 7, 8, or 9." }
  ),
  remarks: z
    .string({ message: "Remarks is a required field" })
    .min(3, "Remarks must be at least 3 characters")
    .max(500, "Remarks must be at most 500 characters")
    .regex(/^[a-zA-Z\s,]+$/, "Remarks can only contain letters and commas").optional(),
  meter_type: z.string().optional(),
  meter_amount: z.string({ message: "Meter amount is an required field" }).optional(),
  meter_testing: z.string({ message: "Meter testing is an required field" }).optional(),
  roof_top_panel: z
    .string({ message: "Roof top panel is required field" })
    // .regex(/^\d*\.?\d*$/, { message: "Roof top panel must be a valid number" })
    .regex(/^(?:0\.[1-9]\d*|[1-9]\d*(?:\.\d+)?|\d*\.\d*[1-9]\d*)$/, { message: "Must be greater than 0 and valid number" })
    .optional(),
  bank_name: z.string({ message: "Bank name is required field" }).optional(),
  bank_account_no: z.string({ message: "Bank acc is required field" }).min(10).max(16).optional(),
  account_holder_name: z.string({ message: "Ac holder name is required field" }).min(3).max(40).optional(),
  ifsc_code: z.string({ message: "Ifsc code is required field" }).min(11).max(11).optional(),
  bank_branch_name: z.string({ message: "Branch details is required field" }).min(3).max(40).optional(),
  load_reduced: z.string({ message: "Load reduced is required field" }).min(1).optional(),
  cont_load: z.string({ message: "Cont load is required field" }).optional(),
  ele_bill_copy: z.string().optional(),
  letter_signed_applicant: z.string({ message: "Letter signed applicant is required field" }).optional(),
  id_proof_doc: z.string({ message: "Id proof document is required field" }),
  category_phase_type: z.string().optional(),
  category_supply_purpose: z.string().optional(),
  category_add_load_value: z.number().min(1).optional(),
  category_add_load_unit: z.string().optional(),
  category_contract_load: z.string().optional(),
  category_cont_load_unit: z.string().optional()
}).superRefine((data, ctx) => {
  if (['9,14@Load Deration', '9,42@Load Deration (without estimate)'].includes(data.service_type)) {
    const reduced = parseFloat(data.load_reduced);
    const contract = parseFloat(data.contract_load);

    // Required check
    if (!data.load_reduced || data.load_reduced.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "load_reduced is a required field",
        path: ["load_reduced"],
      });
    }

    // Only check numeric values if both are valid numbers
    if (!isNaN(reduced)) {
      if (reduced <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "load_reduced must be greater than 0",
          path: ["load_reduced"],
        });
      }

      if (!isNaN(contract) && reduced > contract) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Load derated should not be greater than contracted load",
          path: ["load_reduced"],
        });
      }
    }
  }
}).superRefine((data, ctx) => {
  if (['9,6@Meter Burnt/Glass Broken', '9,10@Meter Testing', '9,3@Shifting of Meter/Service', '9,51@Shifting of Service (Extension)'].includes(data.service_type)) {
    if (!data.meter_type || data.meter_type.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Meter type is an required field",
        path: ["meter_type"],
      });
    }
  }
})
  .superRefine((data, ctx) => {
    if (data.service_type === '9,17@Net Metering') {

      const contractLoad = parseInt(data.contract_load || "0");

      const requireMeter =
        data.scheme_type === "pm_surya" &&
        contractLoad > 10;

      if (requireMeter && !data.meter_type?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            "Meter type is required for PM Surya scheme when contract load is greater than 10",
          path: ["meter_type"],
        });
      }
    }
  })
  .superRefine((data, ctx) => {

    // ✅ Apply everything only for Net Metering
    if (data.service_type === "9,17@Net Metering") {

      /* ---------------- Roof Top Validation ---------------- */

      const value = data.roof_top_panel?.trim();
      const numericValue = Number(value);
      const schemeType = data.scheme_type;

      const contract = Number(data.contract_load);

      if (!value) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Roof top panel is required",
          path: ["roof_top_panel"],
        });
        return;
      }

      if (isNaN(numericValue) || numericValue <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Roof top panel must be a valid positive number",
          path: ["roof_top_panel"],
        });
        return;
      }

      if (schemeType === "pm_surya") {
        if (numericValue > 10) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message:
              "Under PM Surya scheme, rooftop panel capacity cannot exceed 10 kW",
            path: ["roof_top_panel"],
          });
        }
      } else {
        if (!isNaN(contract) && numericValue > contract) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message:
              "Roof top panel capacity should not exceed Contract Load",
            path: ["roof_top_panel"],
          });
        }
      }

      /* ---------------- Bank Fields Required ---------------- */

      if (!data.bank_name?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Bank name is a required field",
          path: ["bank_name"],
        });
      }

      if (!data.bank_account_no?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Bank acc no is a required field",
          path: ["bank_account_no"],
        });
      }

      if (!data.account_holder_name?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Acc holder name is a required field",
          path: ["account_holder_name"],
        });
      }

      if (!data.ifsc_code?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "IFSC code is a required field",
          path: ["ifsc_code"],
        });
      }

      if (!data.bank_branch_name?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Branch details is a required field",
          path: ["bank_branch_name"],
        });
      }

    }

  }).superRefine((data, ctx) => {
    const relevantTypes = [
      '9,50@Phase conversion(With estimate)',
      '9,9@LT Additional Load',
      '9,55@LT Additional load (Extension)',
      '9,8@Phase Conversion'
    ];

    if (relevantTypes.includes(data.service_type)) {
      // const valueRaw = data.category_add_load_value?.trim();
      const valueRaw = String(data.category_add_load_value ?? '').trim();

      if (!valueRaw) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Category add load value is required field",
          path: ["category_add_load_value"],
        });
      } else {
        const loadValue = parseFloat(valueRaw);
        if (isNaN(loadValue) || loadValue <= 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Category add load value must be a number greater than 0",
            path: ["category_add_load_value"],
          });
        }
      }

      if (!data.category_phase_type || data.category_phase_type.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Category phase type is required field",
          path: ["category_phase_type"],
        });
      }
    }
  }).superRefine((data, ctx) => {
    if (['9,15@Temp Connection (for festivals)'].includes(data.service_type)) {
      const valueRaw = String(data.category_add_load_value ?? '').trim();
      if (!valueRaw) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Category add load value is required field",
          path: ["category_add_load_value"],
        });
      } else {
        const loadValue = parseInt(valueRaw);
        if (isNaN(loadValue) || loadValue <= 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Category add load value must be a number greater than 0",
            path: ["category_add_load_value"],
          });
        }
      }
    }
  }).superRefine((data, ctx) => {
    if (['9,66@Electrification of Layout', '9,5@Line Shifting / DTR Shifting', '9,54@Shifting of DTR', '9,99@Electrification of Colony', '9,4@Requirement of Additional Poles', '9,15@Temp Connection (for festivals)', '9,12@Other Capital Works'].includes(data.service_type)) {
      if (!data.letter_signed_applicant || data.letter_signed_applicant.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Letter signed applicant is required field",
          path: ["letter_signed_applicant"],
        });
      }
    } else {
      if (!data.ele_bill_copy || data.ele_bill_copy.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Electricity bill copy is required field",
          path: ["ele_bill_copy"],
        });
      }
    }
  }).superRefine((data, ctx) => {
    // If service_type is '9,54@Shifting of DTR', make these fields optional (skip required check)
    if (data.service_type === '9,54@Shifting of DTR' || data.service_type === '9,66@Electrification of Layout' || data.service_type === '9,99@Electrification of Colony' || data.service_type === '9,4@Requirement of Additional Poles' || data.service_type === '9,15@Temp Connection (for festivals)' || data.service_type === '9,12@Other Capital Works' || data.service_type === '9,5@Line Shifting / DTR Shifting') {
      return;
    } else {
      // For other service_type values, these fields are required
      if (!data.category) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Category is required field",
          path: ["category"],
        });
      }
      if (!data.category_type) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Required",
          path: ["category_type"],
        });
      }
      if (!data.load_type) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Load Type is required field",
          path: ["load_type"],
        });
      }
      if (!data.phase_type) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Phase type is required field",
          path: ["phase_type"],
        });
      }
      // if (!data.sc_type) {
      //   ctx.addIssue({
      //     code: z.ZodIssueCode.custom,
      //     message: "Service type is required field",
      //     path: ["sc_type"],
      //   });
      // }
      if (!data.scheme_type) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Required",
          path: ["scheme_type"],
        });
      }
    }
  });

export const billDeskSchema = z.object({
  reg_no: z
    .string({ message: "CSC reg no is required field" })
    .refine((val) => val.length === 10 || val.length === 20, {
      message: "CSC reg no must be either 10 or 20 characters",
    }),
  common_application_no: z.string(),
  circle_name: z.string(),
  consumer_name: z.string(),
  address: z.string(),
  register_date: z.string(),
  est_application_fee: z.string(),
  est_development_charges: z.string(),
  est_security_deposit: z.string(),
  est_capacitor_charges: z.string(),
  apaid_capacitor_charges: z.string(),
  tobepaid_capacitor_charges: z.string(),
  est_service_line_charge: z.string(),
  // est_turnkey_charges: z.string(),
  est_advance_cc_charges: z.string(),
  est_other_charges: z.string(),
  // est_sgst_charges: z.string(),
  // est_cgst_charges: z.string(),
  est_additional_security_deposits: z.string(),
  est_total_amount: z.string(),
  apaid_application_fee: z.string(),
  apaid_development_charges: z.string(),
  apaid_security_deposit: z.string(),
  apaid_service_line_charge: z.string(),
  // apaid_turnkey_charges: z.string(),
  apaid_advance_cc_charges: z.string(),
  apaid_other_charges: z.string(),
  // apaid_sgst_charges: z.string(),
  // apaid_cgst_charges: z.string(),
  apaid_additional_security_deposits: z.string(),
  apaid_total_amount: z.string(),
  tobepaid_application_fee: z.string(),
  tobepaid_development_charges: z.string(),
  tobepaid_security_deposit: z.string(),
  tobepaid_service_line_charge: z.string(),
  // tobepaid_turnkey_charges: z.string(),
  tobepaid_advance_cc_charges: z.string(),
  tobepaid_other_charges: z.string(),
  // tobepaid_sgst_charges: z.string(),
  // tobepaid_cgst_charges: z.string(),
  tobepaid_additional_security_deposits: z.string(),
  tobepaid_total_amount: z.string(),
  paymentType: z.string().optional(),
})

export const newappSeachByRegNoSchema = z.object({
  reg_no: z
    .string({ message: "CSC reg no is required field" })
    .refine((val) => val.length === 10 || val.length === 20, {
      message: "CSC reg no must be either 10 or 20 characters",
    })
})


export const apartmentRegAppartmentDetailsSchema = z.object({
  existing_service: z.enum(["Yes", "No"], { message: "Service Existing is required field" }),
  adjacent_service_no: z.string({ message: "Adjacent service no is required filed" }).min(13, "Adjacent service no must be 13 digits").max(13).optional(),
  no_of_existing_service_conn: z.number().min(1).max(10).optional(),
  apartment_name: z.string({ message: "Apartment name is required field" }).min(3, "Apartment name at least 3 characters").max(30),
  no_of_flats: z.string({ message: "No of flats is required field" }).min(1),
  no_of_domestic_connections: z.string({ message: "No of domestic connections is required field" }).min(1).max(4),
  total_domestic_contracted_load: z.string({ message: "Total Dom Cont Load is required field" }).min(1).max(6),
  no_of_commerical_connections: z.string({ message: "No of commercial connections is required field" }).min(1).max(4),
  total_commerical_contract_load: z.string({ message: "Total commercial contract load is required field" }).min(1).max(6),
  probable_supply_date: z.string({ message: "Supply released date is required field" }).min(1).max(10),
  email_id: z.string({ message: "Email Id is an required field" }).email(),
  mobile_no: z.string({ message: "Mobile number is a required field" })
    .refine(
      (value) => /^[6-9]\d{9}$/.test(value),
      { message: "Mobile number must be 10 digits and start with 6, 7, 8, or 9." }
    ),
  mobile_no_2: z.string({ message: "Mobile number is a required field" })
    .refine(
      (value) => /^[6-9]\d{9}$/.test(value),
      { message: "Mobile number must be 10 digits and start with 6, 7, 8, or 9." }
    ).optional(),
  land_line: z
    .string()
    .regex(/^\d{6,11}$/, "Land line must be 6 to 11 digits")
    .optional()
    .or(z.literal("")),
  circle: z.string({ message: "Circle name is an required field" }),
  mandal: z.string({ message: "Mandal name is an required field" }),
  section: z.string({ message: "Section name is an required field" }),
  connection_door_no: z.string({ message: "Door No.Building Name is required field" }).min(3, "Door no is atleast 3 characters").max(30),
  connection_street: z.string({ message: "Street name Name is required field" }).min(3, "Street name is atleast 3 characters").max(30),
  connection_village: z.string({ message: "Village name is required field" }).min(3, "village name is atleast 3 characters").max(30),
  connection_mandal: z.string({ message: "Mandal name is required field" }).min(3, "Mandal is atleast 3 characters").max(30),
  connection_pincode: z.string({ message: "Pincode No is required field" }).min(6, "Pincode must be 6 digits").max(6),
  existing_service_no_list: z.array(
    z.string()
      .min(13, "Service number must be 13 digits")
      .max(13, "Service number must be 13 digits")
  ).optional()
}).superRefine((data, ctx) => {
  if (data.existing_service === 'Yes') {
    if (!data.no_of_existing_service_conn) {
      ctx.addIssue({
        path: ["no_of_existing_service_conn"],
        code: z.ZodIssueCode.custom,
        message: "No of existing service is required field",
      });
    }
  }
  if (data.existing_service === 'No') {
    if (!data.adjacent_service_no) {
      ctx.addIssue({
        path: ["adjacent_service_no"],
        code: z.ZodIssueCode.custom,
        message: "Adjacent unique service no is required field",
      });
    }
  }
  if (data.no_of_existing_service_conn) {
    // Validate array length matches the specified count
    if (data.existing_service_no_list?.length !== data.no_of_existing_service_conn) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Exactly ${data.no_of_existing_service_conn} service numbers required`,
        path: ["existing_service_no_list"]
      });
    }

    // Validate individual service numbers
    data.existing_service_no_list?.forEach((num, index) => {
      if (!/^\d{13}$/.test(num)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Service number must be 13 digits",
          path: ["existing_service_no_list", index]
        });
      }
    });
  }
});


export const apartmentRegBuilderDetailsSchema = z.object({
  sale_deed_number: z.string({ message: "Sale Deed Number is required field" }).min(2, "Sale Deed is atleast 2 characters").max(30),
  approval_plan_no: z.string({ message: "Approval plan no is required field" }).min(2, "Approval plan no is atleast 2 characters").max(30),
  total_connected_load: z.string({ message: "Total connected load is required field" }).min(1).max(10),
  application_fee: z.string({ message: "Application fee is required field" }).min(1).max(10),
  self_attested: z.string({ message: "Certificate submitted is required field" }),

  // These fields are conditionally required based on certificate_submitted
  occupancy_certification_number: z.string({ message: "Occupancy certificate number is required field" }).min(2, "Occupancy certificate number is atleast 2 characters").max(30).optional(),
  issued_by: z.string({ message: "Issued by authority is required field" }).min(2, "Issued by authority is atleast 2 characters").max(30).optional(),
  issued_date: z.string({ message: "Date of issue is required field" }).min(2).max(30).optional(),
  no_of_flats_as_per_certificate: z.string({ message: "Number of flats is required field" }).min(1).max(4).optional(),

  domestic_application_fee: z.string(),
  domestic_development_charges: z.string(),
  domestic_security_deposit: z.string(),
  commercial_application_fee: z.string(),
  commercial_development_charges: z.string(),
  commercial_security_deposit: z.string(),
  total_amount: z.string(),
  total_development_charges: z.string(),
  total_security_deposit: z.string(),

  company_name: z.string({ message: "Company name is required field" }).min(2, "Company name atleast 2 characters").max(30),
  mch_registration: z.string({ message: "MCH registration id is required field" }).min(2, "MCH registration id atleast 2 characters").max(30),
  name_of_owner_head: z.string({ message: "Owner name is required field" }).min(2, "Owner name atleast 2 characters").max(30),
  panno: z.string({ message: "Pan number is required field" }).min(10, "Pan number must be 10 characters").max(10),
  apartment_door_no: z.string({ message: "Door no is required field" }).min(2, "Door no atleast 2 characters").max(30),
  apartment_street: z.string({ message: "Street name is required field" }).min(2, "Street name atleast 2 characters").max(30),
  apartment_village: z.string({ message: "City is required field" }).min(2, "City atleast 2 characters").max(30),
  apartment_mandal: z.string({ message: "Mandal name is required field" }).min(2, "Mandal name atleast 2 characters").max(30),
  apartment_pincode: z.string({ message: "Pincode no is required field" }).min(6, "Pincode must be 6 digits").max(6),
  apartment_phone_no: z
    .string({ message: "Mobile number is a required field" })
    .regex(/^[6-9]\d{9}$/, {
      message: "Mobile number must start with 6, 7, 8, or 9",
    }),
  apartment_email: z.string({ message: "Email id is required field" }).email(),

  // Optional communication details
  communication_door_no: z.string({ message: "Door no is required field" }).min(2, "Door no atleast 2 characters").max(30),
  communication_street: z.string({ message: "Street is required field" }).min(2, "Street name atleast 2 characters").max(30),
  communication_village: z.string({ message: "City is required field" }).min(2, "City atleast 2 characters").max(30),
  communication_mandal: z.string({ message: "Mandal is required field" }).min(2, "Mandal name atleast 2 characters").max(30),
  communication_pincode: z.string({ message: "Mincode is required field" }).min(6, "Pincode must be 6 digits").max(6),
  communication_phone_no: z.string({ message: "Mobile number is a required field" })
    .regex(/^[6-9]\d{9}$/, {
      message: "Mobile number must start with 6, 7, 8, or 9",
    }),
  communication_email: z.string({ message: "Email is required field" }).email(),
})
  .superRefine((data, ctx) => {
    // Conditional validation based on certificate_submitted value
    if (data.self_attested === "yes") {
      // Make these fields required when certificate_submitted is "yes"
      if (!data.occupancy_certification_number) {
        ctx.addIssue({
          path: ["occupancy_certification_number"],
          code: z.ZodIssueCode.custom,
          message: "Occupancy certificate_no Number is required field",
        });
      }
      if (!data.issued_by) {
        ctx.addIssue({
          path: ["issued_by"],
          code: z.ZodIssueCode.custom,
          message: "Issued by authority is required field",
        });
      }
      if (!data.issued_date) {
        ctx.addIssue({
          path: ["issued_date"],
          code: z.ZodIssueCode.custom,
          message: "Date of issue is required field",
        });
      }
      if (!data.no_of_flats_as_per_certificate) {
        ctx.addIssue({
          path: ["no_of_flats_as_per_certificate"],
          code: z.ZodIssueCode.custom,
          message: "Number of flats is required field",
        });
      }
    }
  });


const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB in bytes
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg"];
export const apartmentRegDetailsSchema = z.object({
  applicant_photo: z.string({ message: 'Applicant photo must be a .jpg file' }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "Applicant photo must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "Applicant photo must be a .jpg file",
  // }),
  id_proof_type: z.string({ message: 'ID proof is required field' }),
  ownership_doc: z.string({ message: 'Ownership document must be a .jpg file' }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "Ownership document must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "Ownership document must be a .jpg file",
  // }),

  id_proof: z.string({ message: 'ID Proof must be a .jpg file' }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "ID Proof must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "ID Proof must be a .jpg file",
  // }),

  ownership_type: z.string({ message: "Ownership type is a required field" }),

  plan_document: z.string({ message: "Plan document must be a .jpg file" }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "Plan document must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "Plan document must be a .jpg file",
  // }),

  occupancy_certificate: z.string({ message: "Occupancy certificate must be a .jpg file" }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "Occupancy certificate must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "Occupancy certificate must be a .jpg file",
  // }),

  location_photo: z.string({ message: "Location photo must be a .jpg file" }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "Location photo must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "Location photo must be a .jpg file",
  // }),

  noc_document: z.string({ message: "NOC document must be a .jpg file" }),
  // .instanceof(File)
  // .refine(file => file.size <= MAX_FILE_SIZE, {
  //   message: "NOC document must be less than 1MB",
  // })
  // .refine(file => ACCEPTED_IMAGE_TYPES.includes(file.type), {
  //   message: "NOC document must be a .jpg file",
  // }),
});

export const contactUsSchema = z.object({
  consumer_name: z.string({ message: "Consumer name is required field" }).min(3, "Consumer name must atleast of 3 characters").max(30),
  mobile_no: z.string({ message: "Mobile number is a required field" })
    .refine(value => /^[6-9]\d{9}$/.test(value), { message: "Mobile number must be 10 digits and start with 6, 7, 8, or 9." }),
  email_id: z.string({ message: "Email Id is required field" }).min(3, "Email id must atleast of 3 characters").max(30),
  remarks: z
    .string({ message: "Query is a required field" })
    .min(3, "Query must be at least 3 characters")
    .max(200, "Query must be at most 500 characters")
    .regex(/^[a-zA-Z\s,]+$/, "Query can only contain letters and commas")

})
